import { createFileRoute } from '@tanstack/react-router';
import { AUTH_REDIRECT_REASON_PARAM, LOCATION_REVOKED_REASON } from '@selfinspectionorg/auth';
import { LoginView } from '@/modules/auth';
import { PageMetadata } from '@/app/PageMetadata';
import { first } from '@/app/searchSerialization';

export const Route = createFileRoute('/login')({
  // Optional keys so other flows can `navigate({ to: '/login' })` without providing search.
  validateSearch: (search: Record<string, unknown>): { returnUrl?: string; reason?: string } => ({
    returnUrl: first(search.returnUrl),
    [AUTH_REDIRECT_REASON_PARAM]: first(search[AUTH_REDIRECT_REASON_PARAM]),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const isLocationRevoked = search[AUTH_REDIRECT_REASON_PARAM] === LOCATION_REVOKED_REASON;

  return (
    <>
      <PageMetadata title="Sign In | Self Inspection" />
      <LoginView isLocationRevoked={isLocationRevoked} />
    </>
  );
}
